<div (click)="focus()" class="row rounded-2 background-light-gray pointer pointer-hover-blue m-1 p-2">
    <div class="col-2">
        <app-precipitation-svg [online]="true" class="img-fluid img-max m-auto"></app-precipitation-svg>
    </div>
    <div class="col-10 m-auto">
        <div class="row m-auto">
            <div class="fw-bold text-truncate">{{ precipitationSamplePoint()?.name || '-' }}</div>
            <div class="{{ statusMessageColorClass() }}">{{ statusMessage() }}</div>
            @if (precipitationSamplePoint()?.synchronizationStatus === SynchronizationStatus.syncPending) {
                <i class="fa-solid fa-hourglass-half color-warning"></i>
            }
        </div>
    </div>
</div>
